import { storybookReady } from '../../../core/js/utils'

let storybook

(async function () {
  storybook = await storybookReady()

  document.querySelectorAll('.RelatedBrands').forEach(item => {
    new RelatedBrands(item)
  })
})()

class RelatedBrands {
  constructor (element) {
    storybook && console.log('RelatedBrands')

    this.element = element

    this.element.querySelectorAll('img').forEach(item => {
      item.addEventListener('lazyloaded', () => {
        storybook && console.log('lazyloaded')
        if (!item.complete || (typeof item.naturalWidth === 'undefined') || (item.naturalWidth === 0)) {
          item.addEventListener('error', () => {
            storybook && console.log('error')
            item.outerHTML = '<div>' + item.alt + '</div>'
          })
          item.src = item.src.replace(/\/resolutions\/res-l100x100\//, '/original/')
        }
      })
    })
  }
}
